import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import * as ReactDOM from 'react-dom';

import { App, PreziData } from './GalleryPage/App';
import { CategoryData } from './App';

declare var Raven: any;

Raven.context(() => {
    ReactDOM.render(
        <BrowserRouter>
            <App
                categories={ (window as any).props.categories as Array<CategoryData> }
                prezis={ (window as any).props.prezis as Array<PreziData> }
                categoryString={ (window as any).props.categoryString }
            />
        </BrowserRouter>,
        document.getElementById('app'),
    );
});



// WEBPACK FOOTER //
// ./assets/js/GalleryIndex.tsx